import { baseApi } from "@/shared/api";
import type {
  PayrollDetailResponse,
  GeneratePayrollDto,
  ApprovePayrollDto,
  MarkPaidDto,
} from "../types";

export const payrollApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    generatePayroll: builder.mutation<PayrollDetailResponse, GeneratePayrollDto>({
      query: (body) => ({
        url: `/api/accounting/payrolls/generate/`,
        method: "POST",
        body,
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "Payrolls" as const, id: "LIST" }],
    }),

    approvePayroll: builder.mutation<PayrollDetailResponse, { id: number; body?: ApprovePayrollDto }>({
      query: ({ id, body = {} }) => ({
        url: `/api/accounting/payrolls/${id}/approve/`,
        method: "POST",
        body,
        credentials: "include" as const,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Payrolls" as const, id },
        { type: "Payrolls" as const, id: "LIST" },
        "SmetaData",
        "Budget",
      ],
    }),

    markPayrollPaid: builder.mutation<PayrollDetailResponse, { id: number; body?: MarkPaidDto }>({
      query: ({ id, body = {} }) => ({
        url: `/api/accounting/payrolls/${id}/mark-paid/`,
        method: "POST",
        body,
        credentials: "include" as const,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Payrolls" as const, id },
        { type: "Payrolls" as const, id: "LIST" },
      ],
    }),

    deletePayroll: builder.mutation<void, number>({
      query: (id) => ({
        url: `/api/accounting/payrolls/${id}/`,
        method: "DELETE",
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "Payrolls" as const, id: "LIST" }],
    }),
  }),
});

export const {
  useGeneratePayrollMutation,
  useApprovePayrollMutation,
  useMarkPayrollPaidMutation,
  useDeletePayrollMutation,
} = payrollApi;
